import {
  apiRequest,
  cp3kList,
  cp3kDelete,
} from "../../../../../services/adapters/kepegawaian/cp3kService";

class DataTableRepository {
  fetchRowTable = async (query, cancelToken) => {
    return await apiRequest(
      "get",
      cp3kList,
      {
        cancelToken: cancelToken,
        params: query,
      },
      true
    );
  };

  fetchInactive = async (query) => {
    return await apiRequest(
      "post",
      cp3kDelete,
      {
        body: query,
      },
      true
    );
  };
}

export default DataTableRepository;
